import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextFormatItalic24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconTextFormatItalic24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.909 4.716a.75.75 0 0 1 .75-.75h6.522a.75.75 0 1 1 0 1.5H14.5L11.144 18.5h2.492a.75.75 0 0 1 0 1.5H6.75a.75.75 0 0 1 0-1.5H9.6l3.355-13.034h-2.296a.75.75 0 0 1-.75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextFormatItalic24);
